<div class="flex-container">
	<div *ngFor="let parking of parkings; let i = index">
		<table class="{{ getOccupationClass( parking ) }}" cellspacing="0">
			<tbody>
				<tr>
					<td class="parking" colspan="2">{{parkings[i].name}}</td>
				</tr>
				<tr>
					<td class="count">&nbsp;{{parking.occupancy}}&nbsp;/&nbsp;{{parking.capacity }}&nbsp;max.</td>
					<td class="percent">&nbsp;{{ getOccupationPercentage( parking ) }}&nbsp;%&nbsp;</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
